module.exports = __webpack_public_path__ + "static/media/PM87.48097566.png";